
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component
    export default class CookieBanner extends Vue {
        @Prop({type: String, default: ""})
        public readMore!: string;

        @Prop({type: String, default: "Read More"})
        public readMoreLabel!: string;

        @Prop({type: String, default: "Accept"})
        public acceptLabel!: string;

        @Prop({type: String, default: "Reject"})
        public rejectLabel!: string;

        @Prop({type: Boolean, default: true})
        public isProduction!: boolean;

        public cookieName = "hasCookieConsent";
        public isShow = false;
        public trackingCookiesNames = ["__utma", "__utmb", "__utmc", "__utmt", "__utmv", "__utmz", "_ga", "_gat"];

        public mounted() {
            const hasConsent = this.hasConsent(this.cookieName);

            const isBot = /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);

            if (isBot || this.doNotTrack() || hasConsent === false) {
                return;
            }

            if (hasConsent === true) {
                this.launch();
                return;
            }

            this.isShow = true;
        }

        /**
         * EVERY STATISTICS SCRIPTS COME HERE
         */
        public launch() {
            if (this.isProduction) { // Magnolia Public Instance
                const script = document.createElement("script");
                script.innerHTML = `window.dataLayer = window.dataLayer || [];
                                    function gtag(){dataLayer.push(arguments);}
                                    gtag('js', new Date());
                                    gtag('config', 'UA-39066809-1', {'anonymize_ip': true});`;
                document.body.appendChild(script);
            } else {
                console.log("Google Analytics is only working on public");
            }
        }

        public setCookiesConsent(accept = false) {
            this.setCookie(this.cookieName, accept);
            this.isShow = false;

            if (accept) {
                this.launch();
            } else {
                this.deleteTrackingCookies();
            }
        }

        private doNotTrack() {
            const dnt = navigator.doNotTrack || window.doNotTrack;
            const canTrack = (dnt !== null && dnt !== undefined) ? (dnt && dnt !== "yes" && dnt !== "1") : true;

            return !(canTrack || this.isProduction);
        }

        public hasConsent(cookieName: string) {
            return window.document.cookie.indexOf(cookieName + "=true") > -1 ? true :
                window.document.cookie.indexOf(cookieName + "=false") > -1 ? false : null;
        }

        public setCookie(cookieName: string, cookieValue: boolean) {
            const date = new Date();
            const cookieTimeout = 33696e6;
            date.setTime(date.getTime() + cookieTimeout);
            window.document.cookie = cookieName + "=" + cookieValue + ";expires=" + date.toUTCString() + ";path=/";
        }

        public deleteTrackingCookies() {
            const self = this;
            this.trackingCookiesNames.map(function(cookieName) {
                self.deleteCookie(cookieName);
            });
        }

        public deleteCookie(cookieName: string) {
            const hostname = window.document.location.hostname;
            if (hostname !== null) {
                window.document.cookie = cookieName + "=; domain=." + hostname + "; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/";
                window.document.cookie = cookieName + "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/";
            }
        }
    }
